import React, { useState, useEffect } from "react";
import {
  ArrowLeft,
  PlusCircle,
  Eye,
  Edit,
  Edit2,
  Trash2,
  Lock,
} from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Popconfirm, Switch } from "antd";

import { message } from "antd";
import {
  useDeleteUserGroupMutation,
  useGetAllUserGroupQuery,
  useInsertUserGroupMutation,
  useUpdateUserGroupMutation,
} from "AppQuries/user/user-group";
import UserGroupModal from "Components/Modal/userGroup";
import { userGroupValidation } from "core/Operations/ValidationSchema/userValidationSchema";
import { encrypt } from "core/Operations/cryptHelper";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const UserGroup = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useGetAllUserGroupQuery(
    {
      companyCode: userData?.companyCode,
      //   isTrue: showActiveOnly,
    },
    {
      enabled: userData?.companyCode,
    }
  );
  const methods = useForm({
    resolver: yupResolver(userGroupValidation),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutate: addItem, isPending: isAdding } = useInsertUserGroupMutation();
  const { mutate: updateItem, isPending: isUpdating } =
    useUpdateUserGroupMutation();

  const { mutate: deleteItem, isPending: isDeleting } =
    useDeleteUserGroupMutation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ItemData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        id: _id + 1,
        ...d,
      }))
    : [];

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData?.companyCode,
      userGroupCode: "",
      userGroupName: "",
      createUser: userData?.userName,
      mode: "I",
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: item.companyCode,
      userGroupCode: item.userGroupCode,
      userGroupName: item.userGroupName,
      createUser: item.createUser,
      mode: "E",
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteItem(payload, {
      onSuccess: (data) => {
        if (data) {
          message.success("User Group Deleted Successfully.");
          setSelectedItem(null);
          setShow(false);
          GetItems();
        } else {
          message.success(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        message.success(error.message || "Something went wrong.");
      },
    });
  };

  const onSubmit = async (payload) => {
    if (selectedItem) {
      updateItem(payload, {
        onSuccess: (data) => {
          if (data) {
            message.success("User Group Updated Successfully.");
            setSelectedItem(null);
            setShow(false);
            GetItems();
          } else {
            message.success(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          message.success(error.message || "Something went wrong.");
        },
      });
    } else {
      addItem(payload, {
        onSuccess: (data) => {
          console.log(data);
          if (data) {
            message.success("User Group Successfully");
            setShow(false);
            GetItems();
          } else {
            message.danger(data?.[0]?.errorMessage || "Something went wrong.");
          }
        },
        onError: (error) => {
          message.danger(error.message || "Something went wrong.");
        },
      });
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowErrorToast(false);
      setShowSuccessToast(false);
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [showErrorToast, showSuccessToast]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      render: (text, record) => <>{text}</>,
    },

    {
      title: "User Group Code",
      dataIndex: "userGroupCode",
      sorter: (a, b) => a.userGroupCode.length - b.userGroupCode.length,
    },
    {
      title: "User Group Name",
      dataIndex: "userGroupName",
      sorter: (a, b) => a.userGroupName.length - b.userGroupName.length,
    },
    {
      title: "Created User",
      dataIndex: "createUser",
      sorter: (a, b) => a.createUser.length - b.createUser.length,
    },
    // {
    //   title: "Status",
    //   dataIndex: "isActive",
    //   render: (text, record) => (
    //     <>
    //       {text === true && (
    //         <div className="badges badge-linesuccess">Active</div>
    //       )}
    //       {text === false && (
    //         <div className="badges badge-linedanger">In Active</div>
    //       )}
    //     </>
    //   ),
    // },

    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>

          {/* {record.isActive === true && (<OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger> */}
          <Can
            accessModule={accessCodes.users}
            accessCode={accessCodes.user_group}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Role Management</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to={`${all_routes.user_role_management}/${
                  record.userGroupCode
                }?userGroupName=${encrypt(record.userGroupName)}`}
              >
                <i
                  data-feather="sheild"
                  className="feather feather-shield shield"
                ></i>
              </Link>
            </OverlayTrigger>
          </Can>
          <Can
            accessModule={accessCodes.users}
            accessCode={accessCodes.user_group}
            accessType="haveDelete"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
            >
              <Link className="me-2 p-2" to="#">
                <Popconfirm
                  title="Are you sure to Delete?"
                  onConfirm={() => deleteItemHandler(record.userGroupCode)}
                >
                  <Trash2 className="feather-delete" />
                </Popconfirm>
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  useEffect(() => {
    if (isMount) GetItems();

    setIsMount(true);
  }, [showActiveOnly]);

  if (isLoading || isAdding || isUpdating) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>User Group</h4>
              <h6>Manage users</h6>
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.users}
                accessCode={accessCodes.user_group}
                accessType="haveAdd"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add User Group</Tooltip>
                  }
                >
                  <Link
                    to="#"
                    className="btn btn-added"
                    onClick={handleAddClick}
                  >
                    <PlusCircle className="me-2" />
                    Add
                  </Link>
                </OverlayTrigger>
              </Can>
              &nbsp;
              {/* <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link
                  to={`${all_routes.Group}`}
                  className="btn btn-added btn-secondary"
                >
                  <ArrowLeft className="me-2" />
                  Back
                </Link>
              </OverlayTrigger> */}
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={false}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  {/* <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) => setShowActiveOnly(checked)}
                              />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <UserGroupModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default UserGroup;
